import { render, staticRenderFns } from "./EventPreviewCompactCard.vue?vue&type=template&id=5ae5f36d&scoped=true"
import script from "./EventPreviewCompactCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventPreviewCompactCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventPreviewCompactCard.vue?vue&type=style&index=0&id=5ae5f36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5f36d",
  null
  
)

export default component.exports